import {
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";

import { notify } from "../../lib/notify";
import { useAppNavigate } from "../../routes/useAppNavigate";
import { useMenu } from "../../hooks/useMenu";
import { useGlobalSignout } from "../../hooks/useGlobalSignout";
import { useLoginUser } from "../../hooks/useLoginUser";
import { useModal } from "../../hooks/useModal";
import ConfirmLogoutModal from "./ConfirmLogoutModal";
import { useState } from "react";
import { handleError } from "../../utils/error/handleError";

const UserMenu = () => {
  const { publicNavigate, meNavigate } = useAppNavigate();
  const menu = useMenu();
  const { user } = useLoginUser();
  const { signOut } = useGlobalSignout();
  const logoutModal = useModal();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      await signOut();
      notify("ログアウトしました");
      publicNavigate.login({ replace: true });
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <IconButton
        color="inherit"
        onClick={menu.onOpen}
        size="medium"
        disabled={!user}
      >
        <AccountCircleIcon />
      </IconButton>
      <Menu
        anchorEl={menu.anchorEl}
        open={menu.open}
        onClose={menu.onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ m: 2 }}>
          <Typography variant="body2">{`${user?.userName}`}</Typography>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
            }}
          >{`(ログインID: ${user?.loginId})`}</Typography>
        </Box>
        <Divider />
        <Box sx={{ mt: 1 }}>
          <MenuItem
            onClick={() => {
              meNavigate.detail();
            }}
          >
            <ListItemIcon>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>設定</ListItemText>
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={() => {
              logoutModal.onOpen();
              menu.onClose();
            }}
            sx={{ color: "error.main" }}
          >
            <ListItemIcon>
              <LogoutIcon color="error" fontSize="small" />
            </ListItemIcon>
            <ListItemText>ログアウト</ListItemText>
          </MenuItem>
        </Box>
      </Menu>
      <ConfirmLogoutModal
        open={logoutModal.open}
        onClose={logoutModal.onClose}
        onLogout={handleLogout}
        isLogouting={isLoading}
      />
    </>
  );
};

export default UserMenu;
